import { Config, PerEnvironmentConfigs } from '@/config/config'
import '@vgw/multibrand-fe-styles/css/themes/vanilla.css'

const GRAFANA_APP_NAME = 'Vanilla'
const BRAND_NAME = 'Vanilla'
const BRAND_CODE = 'VAN'

const devConfig: Config = {
  name: `${BRAND_NAME}`,
  code: `${BRAND_CODE}`,
  keycloak: {
    url: 'https://auth.dev-vgw-vanilla.com/realms',
    realm: 'VAN',
    clientId: 'vanilla-spa',
  },

  gamGalleryViewApiUrl: 'https://api.gap-dev.vgwgames.com/gallery/view',
  gamGalleryUserPreferencesApiUrl:
    'https://api.gap-dev.vgwgames.com/preferences',
  gamGalleryTickersApiUrl: 'https://api.gap-dev.vgwgames.com/tickers',
  pamPlayerTokensApiUrl: 'https://pam.dev-vgw-vanilla.com/player-tokens',
  pamStoreApiUrl: 'https://pam.dev-vgw-vanilla.com/store/v1',
  pamAmoeApiUrl: 'https://pam.dev-vgw-vanilla.com/pay-hub',
  pamAccountApiUrl: 'https://pam.dev-vgw-vanilla.com/player-identity',
  pamKycApiUrl: 'https://pam.dev-vgw-vanilla.com/kyc',
  pamNotificationsInboxApiUrl: 'https://pam.dev-vgw-vanilla.com/communications',
  pamPlayerTokensHistoryApiUrl:
    'https://pam.dev-vgw-vanilla.com/player-tokens-history',
  pamRedemptionApiUrl: 'https://pam.dev-vgw-vanilla.com/pay-hub',
  gamPeriodicBonusServiceApiUrl: 'https://api.gap-dev.vgwgames.com',
  payPurchasesApiUrl: 'https://payments.dev.vgwgroup.net',
  payRedemptionsApiUrl: 'https://payments.dev.vgwgroup.net',
  pamRsgApiUrl: 'https://pam.dev-vgw-vanilla.com',
  pamPurchaseLimitsApiUrl: 'https://pam.dev-vgw-vanilla.com',
  gamGameRoundInfoApiUrl: 'https://api.gap-dev.vgwgames.com',
  gamQuestsPlayerApiUrl: 'https://api.gap-dev.vgwgames.com',
  amplitude: {
    apiKey: 'b19233b5ca81aca0f4c9e511bcfa9c3a',
    loggingEnabled: false,
    region: 'EU',
    deploymentKey: 'client-Vh3CNSskB5ucSVJajq8F1T7vVR9GOVEG',
  },
  helpCenterFormUrl:
    'https://vgw--develop.sandbox.my.site.com/HelpLWR/contact-form',
  helpCenterUrl: 'https://vgw--stage.sandbox.my.site.com/HelpLWR',
  // hero banner type by page
  heroBannerType: {
    lobby: 'carouselOverlayed',
    category: 'simple',
  },
  features: {
    isHeroBannerEnabled: true,
    isAvailableToPlayers: true,
  },
  braze: {
    apiKey: 'ed3bf3a9-e686-472b-8e5a-b674be61ac46',
    baseUrl: 'sdk.iad-01.braze.com',
  },
  postalRequestMoreInfoUrl:
    'https://pam.dev-vgw-vanilla.com/legal/sweeps-rules',
  pamLegalDocumentsUrl: 'https://pam.dev-vgw-vanilla.com/legal',
  ageRestriction: 21,
  grafana: {
    isEnabled: true,
    url: 'https://faro-collector-prod-eu-west-2.grafana.net/collect/13a99a8f45642bff67e1fbc6b577b97b',
    appName: GRAFANA_APP_NAME,
  },
  minimumRedemptionThreshold: 5000,
  mobileMenuNavbar: {
    variant: 'primary',
  },
  defaultCurrency: 'USD',
  socialMediaLinks: {
    facebook: 'https://www.facebook.com',
    instagram: 'https://www.instagram.com',
    x: 'https://www.x.com',
  },
  playForFreeSocialLink: 'https://www.facebook.com/UnitedSlots',
  cookieNoticeLink: 'https://test-vgw-vanilla.com/legal/cookie-notice',
}

const testConfig: Config = {
  name: `${BRAND_NAME}`,
  code: `${BRAND_CODE}`,
  keycloak: {
    url: 'https://auth.test-vgw-vanilla.com/realms',
    realm: 'VAN',
    clientId: 'vanilla-spa',
  },

  gamGalleryViewApiUrl: 'https://api.gap-test.vgwgames.com/gallery/view',
  payPurchasesApiUrl: 'https://payments.test.vgwgroup.net',
  payRedemptionsApiUrl: 'https://payments.test.vgwgroup.net',
  gamGalleryUserPreferencesApiUrl:
    'https://api.gap-test.vgwgames.com/preferences',
  gamQuestsPlayerApiUrl: 'https://api.gap-test.vgwgames.com',
  gamGalleryTickersApiUrl: 'https://api.gap-test.vgwgames.com/tickers',
  pamStoreApiUrl: 'https://pam.test-vgw-vanilla.com/store/v1',
  pamAmoeApiUrl: 'https://pam.test-vgw-vanilla.com/pay-hub',
  pamAccountApiUrl: 'https://pam.test-vgw-vanilla.com/player-identity',
  pamRsgApiUrl: 'https://pam.test-vgw-vanilla.com',
  pamPlayerTokensHistoryApiUrl:
    'https://pam.test-vgw-vanilla.com/player-tokens-history',
  gamGameRoundInfoApiUrl: 'https://api.gap-test.vgwgames.com',
  pamRedemptionApiUrl: 'https://pam.test-vgw-vanilla.com/pay-hub',
  gamPeriodicBonusServiceApiUrl: 'https://api.gap-test.vgwgames.com',
  pamPurchaseLimitsApiUrl: 'https://pam.test-vgw-vanilla.com',
  pamPlayerTokensApiUrl: 'https://pam.test-vgw-vanilla.com/player-tokens',
  pamKycApiUrl: 'https://pam.test-vgw-vanilla.com/kyc',
  pamNotificationsInboxApiUrl:
    'https://pam.test-vgw-vanilla.com/communications',
  amplitude: {
    apiKey: '8a66f897decb45af2638ac040e93c74a',
    loggingEnabled: false,
    region: 'EU',
    deploymentKey: 'client-3Wu7w1TrIfvPeN1Jiin06mlmTzEzCHZD',
  },
  helpCenterFormUrl:
    'https://vgw--stage.sandbox.my.site.com/HelpLWR/contact-form/',
  helpCenterUrl: 'https://vgw--stage.sandbox.my.site.com/HelpLWR',
  heroBannerType: {
    lobby: 'carouselOverlayed',
    category: 'simple',
  },
  features: {
    isHeroBannerEnabled: true,
    isAvailableToPlayers: true,
  },
  braze: {
    apiKey: 'ed3bf3a9-e686-472b-8e5a-b674be61ac46',
    baseUrl: 'sdk.iad-01.braze.com',
  },
  postalRequestMoreInfoUrl:
    'https://pam.test-vgw-vanilla.com/legal/sweeps-rules',
  pamLegalDocumentsUrl: 'https://pam.test-vgw-vanilla.com/legal',
  ageRestriction: 21,
  grafana: {
    isEnabled: true,
    url: 'https://faro-collector-prod-eu-west-2.grafana.net/collect/5b2b6b538c9e5c54942589c3a7ab8aeb',
    appName: GRAFANA_APP_NAME,
  },
  minimumRedemptionThreshold: 5000,
  mobileMenuNavbar: {
    variant: 'primary',
  },
  defaultCurrency: 'USD',
  socialMediaLinks: {
    facebook: 'https://www.facebook.com',
    instagram: 'https://www.instagram.com',
    x: 'https://x.com',
  },
  playForFreeSocialLink: 'https://www.facebook.com/UnitedSlots',
  cookieNoticeLink: 'https://test-vgw-vanilla.com/legal/cookie-notice',
}

const productionConfig: Config = {
  name: `${BRAND_NAME}`,
  code: `${BRAND_CODE}`,
  keycloak: {
    url: 'https://auth.vgw-vanilla.com/realms',
    realm: 'VAN',
    clientId: 'vanilla-spa',
  },
  gamGalleryViewApiUrl: 'https://api.gap.vgwgames.com/gallery/view',
  gamGalleryUserPreferencesApiUrl: 'https://api.gap.vgwgames.com/preferences',
  gamGalleryTickersApiUrl: 'https://api.gap.vgwgames.com/tickers',
  pamPlayerTokensApiUrl: 'https://pam.vgw-vanilla.com/player-tokens',
  pamKycApiUrl: 'https://pam.dev-vgw-vanilla.com/kyc',
  pamNotificationsInboxApiUrl: 'https://pam.dev-vgw-vanilla.com/communications',
  gamQuestsPlayerApiUrl: 'https://api.gap.vgwgames.com',
  pamStoreApiUrl: 'https://pam.dev-vgw-vanilla.com/store/v1',
  pamAmoeApiUrl: 'https://pam.dev-vgw-vanilla.com/pay-hub',
  pamAccountApiUrl: 'https://pam.vgw-vanilla.com/player-identity',
  pamRsgApiUrl: 'https://pam.vgw-vanilla.com/rsg',
  pamPlayerTokensHistoryApiUrl:
    'https://pam.vgw-vanilla.com/player-tokens-history',
  gamGameRoundInfoApiUrl: 'https://api.gap.vgwgames.com',
  pamRedemptionApiUrl: 'https://pam.vgw-vanilla.com/pay-hub',
  gamPeriodicBonusServiceApiUrl: 'https://api.gap.vgwgames.com',
  payPurchasesApiUrl: 'https://payments.vgwgroup.net',
  payRedemptionsApiUrl: 'https://payments.vgwgroup.net',
  amplitude: {
    apiKey: '',
    loggingEnabled: false,
    region: 'EU',
    deploymentKey: '',
  },
  pamPurchaseLimitsApiUrl: 'https://pam.dev-vgw-vanilla.com',
  helpCenterFormUrl:
    'https://vgw--stage.sandbox.my.site.com/HelpLWR/contact-form',
  helpCenterUrl: 'https://vgw--stage.sandbox.my.site.com/HelpLWR',
  heroBannerType: {
    lobby: 'carouselOverlayed',
    category: 'simple',
  },
  features: {
    isHeroBannerEnabled: true,
    isAvailableToPlayers: true,
  },
  braze: {
    apiKey: 'ed3bf3a9-e686-472b-8e5a-b674be61ac46',
    baseUrl: 'sdk.iad-01.braze.com',
  },
  postalRequestMoreInfoUrl: '',
  pamLegalDocumentsUrl: 'https://pam.dev-vgw-vanilla.com/legal',
  ageRestriction: 21,
  grafana: {
    isEnabled: true,
    url: 'https://faro-collector-prod-eu-west-2.grafana.net/collect/884e8f82f4e4da069c1f2503f7b1f065',
    appName: GRAFANA_APP_NAME,
  },
  minimumRedemptionThreshold: 5000,
  mobileMenuNavbar: {
    variant: 'primary',
  },
  defaultCurrency: 'USD',
  socialMediaLinks: {
    facebook: 'https://www.facebook.com',
    instagram: 'https://www.instagram.com',
    x: 'https://x.com',
  },
  playForFreeSocialLink: 'https://www.facebook.com/UnitedSlots',
  cookieNoticeLink: 'https://test-vgw-vanilla.com/legal/cookie-notice',
}

const BRAND_CONFIGS: PerEnvironmentConfigs = {
  local: {
    ...devConfig,
    grafana: {
      isEnabled: false,
    },
  },
  dev: {
    ...devConfig,
  },
  test: {
    ...testConfig,
  },
  prod: {
    ...productionConfig,
  },
}

export default BRAND_CONFIGS
